module.exports = __webpack_public_path__ + "assets/a14b53a6649fc6daa2d6ce6dff4e09b9.svg";